import { Box, Grid, Typography } from "@mui/material"
import React from "react"
import { BSBimModelInfo } from "./BSBimModelInfo"
import { VariantsOverviewHeader } from "./VariantsOverviewHeader"
import { VariantsOverviewList } from "./VariantsOverviewList"
import { BSBimModel } from "../../../../../../../core/dto/beem-shot/BSBimModel/BSBimModel"
import { customPalette } from "../../../../../../../../theme"
import { formatToFrenchWithHours } from "../../../../../../../core/services/date-service"
import { BOTTOM_NAVIGATION_HEIGHT } from "../../../../../../../components/buttons/navigate-button/CustomBottomNavigation"

interface IProps {
  selectedBSBimModel: BSBimModel
}

export function BSBimModelOverview({ selectedBSBimModel }: Readonly<IProps>): React.JSX.Element {
  return (
    <Box
      display="flex"
      flexGrow={1}
      flexShrink={1}
      border={2}
      borderRadius={3}
      justifyContent="flex-start"
      flexDirection="column"
      alignContent="flex-start"
      alignItems="center"
      borderColor={customPalette.lightGray7}
      my={3}
      sx={{
        backgroundColor: customPalette.lightGray6,
        height: `calc(100vh  - ${BOTTOM_NAVIGATION_HEIGHT} - 140px)`,
        overflow: "auto",
        p: 3,
        pt: 0,
        cursor: "default",
      }}>
      <Grid container spacing={2} alignItems="center" justifyContent="space-between" sx={{ pt: 2 }}>
        <Grid item xs={12}>
          <Typography variant="subtitle1" fontSize={11} fontWeight={400} sx={{ color: customPalette.subtitleGray }}>
            {`Dernière mise à jour le ${formatToFrenchWithHours(selectedBSBimModel.lastModifiedDate)}`}
          </Typography>
        </Grid>
        <Grid item xs={1} />
        <Grid item xs={9} display="flex" justifyContent="center" alignItems="center">
          <Typography variant="h4" fontWeight={600} textAlign="center" sx={{ color: customPalette.darkBlue2 }}>
            Surfaces
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <BSBimModelInfo bsBimModel={selectedBSBimModel} />
        </Grid>

        <VariantsOverviewHeader />
        <VariantsOverviewList />
      </Grid>
    </Box>
  )
}
